module.exports = __webpack_public_path__ + "static/media/Manual-Maker-Hero-Free-App-Round.ab5df9ec.jpg";